import Restaurant from './Restaurant'

export default Restaurant



// WEBPACK FOOTER //
// ./src/features/RestaurantAndCafe/components/Restaurant/index.js